import React, { useEffect, useRef, useState } from 'react';
import { getAccountID, getWebhookID, postWP } from 'services/wp'
import Page1 from './pages/Page1';
import Page2 from './pages/Page2';
import { useNavigate } from 'react-router-dom';
import Modal from 'components/Modal';
import Loading from 'components/Loading';
import AlertError from 'components/AlertError';
import { sendToGHL } from 'services/ghl';
import formatDate from 'utils/formatDate';
import printDocument from 'utils/printDocument';
import calcBirthToAge from 'utils/calcBirthToAge';
import fakeDelay from 'utils/fakeDelay';
import getLocalStorage from 'utils/getLocalStorage';

import ReactSignatureCanvas from 'react-signature-canvas';
import { RiFolderUploadFill } from "react-icons/ri";
import { FaFileSignature } from "react-icons/fa6";
import { CiEraser } from "react-icons/ci";
import getDeviceFingerprint from 'utils/getDeviceFingerPrint';
import TermsAndConditionContent from 'routes/terms_and_condition/content/TermsAndConditionContent';
import PrivacyPolicyContent from 'routes/privacy_policy/content/PrivacyPolicyContent';
import { validatePhone, formatPhoneNumber } from 'utils/validatePhone';
import { validateZip, formatZipCode } from 'utils/validateZip';
import { withSubmissionTimeout, getSubmissionErrorMessage } from 'utils/submissionTimeout';

const TCPA_ENROLLMENT_DISCLAIMER =
  "I agree to the Terms & Conditions, Privacy Policy, and Communication Agreement. By checking this box and clicking 'Submit Enrollment', I provide my express written consent for Insurance Enterprise USA to contact me regarding health insurance options via email, phone calls, and text messages at the number provided above, including automated technology. Consent is not a condition of purchase.";

const EnrollmentForm = () => {


    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const [styledInput, setStyledInput] = useState({
        border: '1px solid rgba(0,0,0,0.2)'
    });
    const styledDisabledInput = {
        border: '1px solid rgba(0,0,0,0.18)',
        backgroundColor: '#e5e7eb',
        color: '#4b5563',
    };
    const [lockedQuoteFields, setLockedQuoteFields] = useState({
        isFromQuote: false,
        healthPlan: false,
        age: false,
    });

    const [isValid, setIsValid] = useState(true);
    const styledNotValid = {
        border: '2px solid #dc2626',
        backgroundColor: 'rgba(254, 226, 226, 0.85)',
    };
    const [sent, setSent] = useState(true);
    const [sending, setSending] = useState(false);
    const navigate = useNavigate()

    const [displayedDateFormats, setDisplayedDateFormats] = useState({
        desiredEffectiveDate: '',
        primaryApplicantBirthDate: '',
        primaryApplicantLastDoctorVisitDate: '',
        spouseBirthDate: '',
        spouseLastDoctorVisitDate: '',
        dependents: Array(5).fill({ birthDate: '' }),
        healthQuestions: Array(5).fill({ dateOfOnset: '' }),
        applicantSignatureDate: '',
        spouseSignatureDate: ''
    });

    const [plansData, setPlansData] = useState({
        desiredEffectiveDate: '',
        quotedMonthlyPremium: '',
        deductible: '',
        healthPlan: '',
        dentalPlan: ''
    });
    const [plansValidity, setPlansValidity] = useState({
        desiredEffectiveDate: true,
        quotedMonthlyPremium: true,
        deductible: true,
        healthPlan: true,
        dentalPlan: true,
    });

    const [primaryApplicantData, setPrimaryApplicantData] = useState({
        lastName: '',
        firstName: '',
        gender: '',
        ssn: '',
        birthDate: '',
        age: '',
        birthStateCounty: '',
        homeAddress: '',
        city: '',
        county: '',
        state: '',
        zip: '',
        phoneNumber: '',
        bestTimeToCall: '',
        heightFeet: '',
        heightInch: '',
        weight: '',
        maritalStatus: '',
        email: '',
        employerName: '',
        employerJob: '',
        employerAnnualIncome: '',
        employerAddress: '',
        employerCity: '',
        employerState: '',
        employerZip: '',
    });
    const [primaryApplicantValidity, setPrimaryApplicantValidity] = useState({
        lastName: true,
        firstName: true,
        gender: true,
        ssn: true,
        referredBy: true,
        birthDate: true,
        age: true,
        birthStateCounty: true,
        homeAddress: true,
        city: true,
        county: true,
        state: true,
        zip: true,
        phoneNumber: true,
        bestTimeToCall: true,
        heightFeet: true,
        heightInch: true,
        weight: true,
        maritalStatus: true,
        email: true,
        primaryBeneficiaryName: true,
        primaryBeneficiaryRelationship: true,
        secondaryBeneficiaryName: true,
        secondaryBeneficiaryRelationship: true,
        currentInsuranceProvider: true,
        employerName: true,
        employerJob: true,
        employerAnnualIncome: true,
        employerAddress: true,
        employerCity: true,
        employerState: true,
        employerZip: true,
    });

    const [primaryApplicantDataNotRequired, setPrimaryApplicantDataNotRequired] = useState({
        middleName: '',
        howDidYouFindUs: '',
        aptNumber: '',
        driversLicense: '',
        dlIssuingState: '',
        heightUnit: 'ft',
        referredBy: '',
        doctorName: '',
        doctorPhone: '',
        doctorDateOfLastVisit: '',
        doctorResonForVisit: '', //! Wrong Spelling
        doctorAddress: '',
        doctorSuiteNumber: '',
        doctorCity: '',
        doctorState: '',
        doctorZip: '',
        primaryBeneficiaryName: '',
        primaryBeneficiaryRelationship: '',
        secondaryBeneficiaryName: '',
        secondaryBeneficiaryRelationship: '',
        currentInsuranceProvider: '',
    });


    const [spouseData, setSpouseData] = useState({
        lastName: '',
        firstName: '',
        middleName: '',
        gender: '',
        ssn: '',
        birthDate: '',
        age: '',
        birthStateCounty: '',
        homeAddress: '',
        aptNumber: '',
        city: '',
        county: '',
        state: '',
        zip: '',
        phoneNumber: '',
        bestTimeToCall: {
            am: false,
            pm: true
        },
        heightFeet: '',
        heightInch: '',
        weight: '',
        driversLicense: '',
        email: '',
        primaryBeneficiaryName: '',
        primaryBeneficiaryRelationship: '',
        secondaryBeneficiaryName: '',
        secondaryBeneficiaryRelationship: '',
        currentInsuranceProvider: '',
        doctorName: '',
        doctorPhone: '',
        doctorDateOfLastVisit: '',
        doctorResonForVisit: '',
        doctorAddress: '',
        doctorSuiteNumber: '',
        doctorCity: '',
        doctorState: '',
        doctorZip: '',
        employerName: '',
        employerJob: '',
        employerAnnualIncome: '',
        employerAddress: '',
        employerCity: '',
        employerState: '',
        employerZip: '',
    });

    const [dependents, setDependents] = useState(Array(5).fill(
        {
            lastName: '',
            firstName: '',
            middleName: '',
            gender: '',
            ssn: '',
            birthDate: '',
            age: '',
            heightFeet: '',
            heightInch: '',
            weight: '',
            isFullTimeStudent: ''
        }
    ));

    const [ssnMinMaxValidity, setSsnMinMaxValidity] = useState(true);
    const [routeNumberMinMaxValidity, setRouteNumberMinMaxValidity] = useState(true);
    const [primaryFormatValidity, setPrimaryFormatValidity] = useState({
        phoneNumber: true,
        zip: true,
        email: true,
        employerZip: true,
    });
    const [optionalFieldsValidity, setOptionalFieldsValidity] = useState({
        primaryDoctorPhone: true,
        primaryDoctorZip: true,
        spouseSsn: true,
        spousePhone: true,
        spouseZip: true,
        spouseEmail: true,
        spouseEmployerZip: true,
        spouseDoctorPhone: true,
        spouseDoctorZip: true,
    });


    const handlePlansDataChange = (e) => {
        const { name, value } = e.target;

        if (name === 'quotedMonthlyPremium' || name === 'deductible') {
            return;
        }
        if (name === 'healthPlan' && lockedQuoteFields.healthPlan) {
            return;
        }

        if (name === 'desiredEffectiveDate') {
            setDisplayedDateFormats(prev => ({
                ...prev,
                desiredEffectiveDate: formatDate(value)
            }))
        }

        setShowError(false)

        setPlansData((prevState) => ({
            ...prevState,
            [name]: value,
        }));

        setPlansValidity((prevValidity) => ({
            ...prevValidity,
            [name]: String(value).trim() !== ''
        }));
    }

    const handlePrimaryApplicantChange = (e) => {
        let { name, value } = e.target;

        setShowError(false);

        if (name === 'age') {
            if (lockedQuoteFields.age) {
                return;
            }
            const parsedAge = parseInt(String(value || '').trim(), 10);
            const currentBirthAge = primaryApplicantData.birthDate ? calcBirthToAge(primaryApplicantData.birthDate) : null;
            const shouldClearBirthDate =
                primaryApplicantData.birthDate !== '' &&
                (!value || (!isNaN(parsedAge) && parsedAge >= 18 && parsedAge <= 64 && currentBirthAge !== parsedAge));

            setPrimaryApplicantData((prevState) => ({
                ...prevState,
                age: value,
                ...(shouldClearBirthDate ? { birthDate: '' } : {}),
            }));

            setPrimaryApplicantValidity((prevValidity) => ({
                ...prevValidity,
                age: String(value).trim() !== '',
            }));

            if (shouldClearBirthDate) {
                setDisplayedDateFormats((prev) => ({
                    ...prev,
                    primaryApplicantBirthDate: '',
                }));
            }
            return;
        }

        if (name === 'birthDate') {
            const calculatedAge = value ? calcBirthToAge(value) : '';
            const validAge = calculatedAge !== '' && !isNaN(calculatedAge) && calculatedAge >= 0 ? String(calculatedAge) : '';
            setPrimaryApplicantData(prev => ({
                ...prev,
                birthDate: value,
                age: lockedQuoteFields.age ? prev.age : (prev.age && String(prev.age).trim() !== '' ? prev.age : validAge)
            }));

            setPrimaryApplicantValidity((prevValidity) => ({
                ...prevValidity,
                birthDate: value !== '',
                age: lockedQuoteFields.age ? true : (primaryApplicantData.age && String(primaryApplicantData.age).trim() !== '' ? true : validAge !== '')
            }));

            setDisplayedDateFormats(prev => ({
                ...prev,
                primaryApplicantBirthDate: value ? formatDate(value) : ''
            }));
            return;
        }

        if (name === 'ssn') {
            setSsnMinMaxValidity(true);
            const digitsOnly = value.replace(/\D/g, '').slice(0, 9);
            setPrimaryApplicantData((prevState) => ({
                ...prevState,
                ssn: digitsOnly,
            }));
            setPrimaryApplicantValidity((prevValidity) => ({
                ...prevValidity,
                ssn: digitsOnly !== ''
            }));
            return;
        }

        if (name === 'phoneNumber') {
            value = formatPhoneNumber(value);
            setPrimaryFormatValidity(prev => ({ ...prev, phoneNumber: true }));
        } else if (name === 'zip') {
            value = formatZipCode(value);
            setPrimaryFormatValidity(prev => ({ ...prev, zip: true }));
        } else if (name === 'employerZip') {
            value = formatZipCode(value);
            setPrimaryFormatValidity(prev => ({ ...prev, employerZip: true }));
        } else if (name === 'email') {
            setPrimaryFormatValidity(prev => ({ ...prev, email: true }));
        }

        setPrimaryApplicantData((prevState) => ({
            ...prevState,
            [name]: value,
        }));

        setPrimaryApplicantValidity((prevValidity) => ({
            ...prevValidity,
            [name]: String(value).trim() !== ''
        }));
    }

    const handlePrimaryApplicantDataNotRequired = (e) => {
        let { name, value } = e.target;

        setShowError(false);

        if (name === 'doctorPhone') {
            value = formatPhoneNumber(value);
            setOptionalFieldsValidity(prev => ({ ...prev, primaryDoctorPhone: true }));
        } else if (name === 'doctorZip') {
            value = formatZipCode(value);
            setOptionalFieldsValidity(prev => ({ ...prev, primaryDoctorZip: true }));
        }

        if (name === 'howDidYouFindUs') {
            const nextVal = primaryApplicantDataNotRequired.howDidYouFindUs === value ? '' : value;
            if (nextVal !== 'Referral') {
                setPrimaryApplicantValidity(prev => ({ ...prev, referredBy: true }));
            } else if (!isValid && String(primaryApplicantDataNotRequired.referredBy || '').trim() === '') {
                setPrimaryApplicantValidity(prev => ({ ...prev, referredBy: false }));
            }
            setPrimaryApplicantDataNotRequired(prevState => ({
                ...prevState,
                howDidYouFindUs: nextVal
            }));
            return;
        } else if (name === 'referredBy') {
            setPrimaryApplicantValidity(prev => ({
                ...prev,
                referredBy: primaryApplicantDataNotRequired.howDidYouFindUs === 'Referral' ? String(value).trim() !== '' : true
            }));
        }

        if (name === 'doctorDateOfLastVisit') {
            setDisplayedDateFormats(prev => ({
                ...prev,
                primaryApplicantLastDoctorVisitDate: formatDate(value)
            }))
        }

        setPrimaryApplicantDataNotRequired(prevState => ({
            ...prevState,
            [name]: value
        }))
    }

    const handleSpouseChange = (e) => {
        let { name, value } = e.target;

        setShowError(false);

        if (name === 'birthDate') {
            const calculatedAge = value ? calcBirthToAge(value) : '';
            const validAge = calculatedAge !== '' && !isNaN(calculatedAge) && calculatedAge >= 0 ? String(calculatedAge) : '';
            setSpouseData(prev => ({
                ...prev,
                birthDate: value,
                age: validAge
            }));

            setDisplayedDateFormats(prev => ({
                ...prev,
                spouseBirthDate: value ? formatDate(value) : ''
            }));
            return;
        }

        if (name === 'doctorDateOfLastVisit') {
            setDisplayedDateFormats(prev => ({
                ...prev,
                spouseLastDoctorVisitDate: formatDate(value)
            }))
        }

        if (name === 'ssn') {
            setOptionalFieldsValidity(prev => ({ ...prev, spouseSsn: true }));
            const digitsOnly = value.replace(/\D/g, '').slice(0, 9);
            setSpouseData((prevState) => ({
                ...prevState,
                ssn: digitsOnly,
            }));
            return;
        }

        if (name === 'phoneNumber') {
            value = formatPhoneNumber(value);
            setOptionalFieldsValidity(prev => ({ ...prev, spousePhone: true }));
        } else if (name === 'doctorPhone') {
            value = formatPhoneNumber(value);
            setOptionalFieldsValidity(prev => ({ ...prev, spouseDoctorPhone: true }));
        } else if (name === 'zip') {
            value = formatZipCode(value);
            setOptionalFieldsValidity(prev => ({ ...prev, spouseZip: true }));
        } else if (name === 'employerZip') {
            value = formatZipCode(value);
            setOptionalFieldsValidity(prev => ({ ...prev, spouseEmployerZip: true }));
        } else if (name === 'doctorZip') {
            value = formatZipCode(value);
            setOptionalFieldsValidity(prev => ({ ...prev, spouseDoctorZip: true }));
        } else if (name === 'email') {
            setOptionalFieldsValidity(prev => ({ ...prev, spouseEmail: true }));
        }

        setSpouseData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    }

    const handleDependentsChange = (e, index) => {
        const { name, value } = e.target;

        if (name === 'birthDate') {
            setDependents((prevDependents) => {
                const newDependents = [...prevDependents];
                newDependents[index] = {
                    ...newDependents[index],
                    age: calcBirthToAge(value),
                };
                return newDependents;
            });

            setDisplayedDateFormats(prev => {
                const newDependentsBirthDate = [...prev.dependents];
                newDependentsBirthDate[index] = {
                    ...newDependentsBirthDate[index],
                    birthDate: formatDate(value)
                };
                return {
                    ...prev,
                    dependents: newDependentsBirthDate
                };
            })
        }

        setDependents((prevDependents) => {
            const newDependents = [...prevDependents];
            newDependents[index] = {
                ...newDependents[index],
                [name]: value,
            };
            return newDependents;
        });
    }




    // PAGE 2
    const [image, setImage] = useState(null);
    const [image2, setImage2] = useState(null);
    const [image3, setImage3] = useState(null);
    const [imageValidity, setImageValidity] = useState(true);
    const [image2Validity, setImage2Validity] = useState(true);
    const [image3Validity, setImage3Validity] = useState(true);

    const [anyTobaccoProducts, setAnyTobaccoProducts] = useState({
        anyTobaccoPrimary: '',
        anyTobaccoSpouse: '',
        anyTobaccoDependants: ''
    });
    const [useTobaccoLastTwoYears, setUseTobaccoLastTwoYears] = useState({
        usedTobaccoPrimary: '',
        usedTobaccoSpouse: '',
        usedTobaccoDependants: ''
    });

    const [generalQuestions, setGeneralQuestions] = useState({
        question1: '',
        question2: '',
        question3: '',
        question4: '',
        question5: '',
        question6: '',
        question7: '',
        question8: '',
        question9: '',
        question10: '',
        question11: '',
        question12: '',
        question13: '',
        question14: '',
        question15: '',
        question16: '',
        question17: '',
        question18: '',
        question19: '',
        question20: ''
    });

    const [generalQuestionsValidity, setGeneralQuestionsValidity] = useState({
        question1: true,
        question2: true,
        question3: true,
        question4: true,
        question5: true,
        question6: true,
        question7: true,
        question8: true,
        question9: true,
        question10: true,
        question11: true,
        question12: true,
        question13: true,
        question14: true,
        question15: true,
        question16: true,
        question17: true,
        question18: true,
        question19: true,
        question20: true
    });



    const [anyTobaccoProductsValidity, setAnyTobaccoProductsValidity] = useState(true);
    const [useTobaccoLastTwoYearsValidity, setUseTobaccoLastTwoYearsValidity] = useState(true);

    const [healthQuestions, setHealthQuestions] = useState([
        {
            fullName: '',
            medicalCondition: '',
            prescriptionMedication: '',
            dosage: '',
            frequency: '',
            dateOfOnset: '',
        },
        {
            fullName: '',
            medicalCondition: '',
            prescriptionMedication: '',
            dosage: '',
            frequency: '',
            dateOfOnset: '',
        },
        {
            fullName: '',
            medicalCondition: '',
            prescriptionMedication: '',
            dosage: '',
            frequency: '',
            dateOfOnset: '',
        },
        {
            fullName: '',
            medicalCondition: '',
            prescriptionMedication: '',
            dosage: '',
            frequency: '',
            dateOfOnset: '',
        },
        {
            fullName: '',
            medicalCondition: '',
            prescriptionMedication: '',
            dosage: '',
            frequency: '',
            dateOfOnset: '',
        },
    ]);
    const [healthQuestionsValidity, setHealthQuestionsValidity] = useState([
        {
            fullName: true,
            medicalCondition: true,
            prescriptionMedication: true,
            dosage: true,
            frequency: true,
            dateOfOnset: true,
        },
        {
            fullName: true,
            medicalCondition: true,
            prescriptionMedication: true,
            dosage: true,
            frequency: true,
            dateOfOnset: true,
        },
        {
            fullName: true,
            medicalCondition: true,
            prescriptionMedication: true,
            dosage: true,
            frequency: true,
            dateOfOnset: true,
        },
        {
            fullName: true,
            medicalCondition: true,
            prescriptionMedication: true,
            dosage: true,
            frequency: true,
            dateOfOnset: true,
        },
        {
            fullName: true,
            medicalCondition: true,
            prescriptionMedication: true,
            dosage: true,
            frequency: true,
            dateOfOnset: true,
        },
    ]);






    const [bankInfo, setBankInfo] = useState({
        bankInstitution: '',
        routingNumber: '',
        accountNumber: '',
        accountHolderName: '',
    });
    const [bankInfoValidity, setBankInfoValidity] = useState({
        bankInstitution: true,
        routingNumber: true,
        accountNumber: true,
        accountHolderName: true,
    });

    const [spouseSignatureDate, setSpouseSignatureDate] = useState('');

    const [applicantSignatureDate, setApplicantSignatureDate] = useState({
        date: '',
        validity: true
    });

    const handleApplicantSignatureDate = (e) => {
        const value = e.target.value;

        setDisplayedDateFormats(prev => ({
            ...prev,
            applicantSignatureDate: formatDate(value)
        }))

        setShowError(false)

        setApplicantSignatureDate(prevState => ({
            ...prevState,
            date: value,
            validity: value !== ''
        }))
    }

    const handleBankInfoChange = (e) => {
        const { name, value } = e.target

        setShowError(false)

        if (name === 'routingNumber') {
            setRouteNumberMinMaxValidity(true)
            const digitsOnly = value.replace(/\D/g, '').slice(0, 9);
            setBankInfo((prevState) => ({
                ...prevState,
                routingNumber: digitsOnly,
            }));
            setBankInfoValidity((prevValidity) => ({
                ...prevValidity,
                routingNumber: digitsOnly !== ''
            }));
            return;
        }

        setBankInfo((prevState) => ({
            ...prevState,
            [name]: value,
        }));

        setBankInfoValidity((prevValidity) => ({
            ...prevValidity,
            [name]: String(value).trim() !== ''
        }));
    }

    const handlSpouseSignatureDateChange = (e) => {
        const value = e.target.value

        setDisplayedDateFormats(prev => ({
            ...prev,
            spouseSignatureDate: formatDate(value)
        }))

        setSpouseSignatureDate(value)
    }

    const handleImageUpload = (event) => {
        setShowError(false)
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImage(reader.result);
                setImageValidity(true);
            };
            reader.readAsDataURL(file);
        } else {
            setImageValidity(false);
        }
    };
    const handleImage2Upload = (event) => {
        setShowError(false)
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImage2(reader.result);
                setImage2Validity(true);
            };
            reader.readAsDataURL(file);
        } else {
            setImage2Validity(false);
        }
    };
    const handleImage3Upload = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImage3(reader.result);
                setImage3Validity(true);
            };
            reader.readAsDataURL(file);
        } else {
            setImage3Validity(false);
        }
    };

    const handleAnyTobaccoProductsChange = (e) => {
        setShowError(false);
        setAnyTobaccoProductsValidity(true);
        const { name, value } = e.target;

        setAnyTobaccoProducts(prevState => ({
            ...prevState,
            [name]: value
        }))
    }

    const handleUseTobaccoLastTwoYearsChange = (e) => {
        setShowError(false);
        setUseTobaccoLastTwoYearsValidity(true);
        const { name, value } = e.target;

        setUseTobaccoLastTwoYears(prevState => ({
            ...prevState,
            [name]: value
        }))
    }

    const handleGeneralQuestionsChange = (e) => {
        setShowError(false);
        const { name, value } = e.target;

        setGeneralQuestionsValidity(prevState => ({
            ...prevState,
            [name]: true
        }))

        setGeneralQuestions(prevState => {
            const updated = {
                ...prevState,
                [name]: value
            };
            const stillHasYes = Object.values(updated).some(val => val === 'Yes');
            const hasAnyHealthRowFilled = healthQuestions.some(row =>
                Object.values(row).some(v => String(v || '').trim() !== '')
            );
            if (!stillHasYes) {
                setHealthQuestionsValidity(prevValidity =>
                    prevValidity.map((rowVal, idx) => {
                        const row = healthQuestions[idx];
                        const allEmpty = Object.values(row).every(v => String(v || '').trim() === '');
                        if (allEmpty) {
                            return {
                                fullName: true,
                                medicalCondition: true,
                                prescriptionMedication: true,
                                dosage: true,
                                frequency: true,
                                dateOfOnset: true,
                            };
                        }
                        return rowVal;
                    })
                );
            } else if (!isValid && !hasAnyHealthRowFilled) {
                setHealthQuestionsValidity(prevValidity => {
                    const updatedValidity = [...prevValidity];
                    updatedValidity[0] = {
                        fullName: false,
                        medicalCondition: false,
                        prescriptionMedication: false,
                        dosage: false,
                        frequency: false,
                        dateOfOnset: false,
                    };
                    return updatedValidity;
                });
            }
            return updated;
        })
    }

    const handleForm2Change = (e, index) => {
        setShowError(false);
        const { name, value } = e.target

        if (name === 'dateOfOnset') {
            setDisplayedDateFormats(prev => {
                const newHealthQuestions = [...prev.healthQuestions];
                newHealthQuestions[index] = {
                    ...newHealthQuestions[index],
                    dateOfOnset: formatDate(value)
                };
                return {
                    ...prev,
                    healthQuestions: newHealthQuestions
                }
            })
        }

        setHealthQuestions((prevDependents) => {
            const newDependents = [...prevDependents];
            newDependents[index] = {
                ...newDependents[index],
                [name]: value,
            };

            // check if current row values is all empty
            const currentRow = newDependents[index];
            const allEmpty = Object.values(newDependents[index]).every(v => String(v || '').trim() === '');
            const hasYesInGeneralQuestions = Object.values(generalQuestions).some(val => val === 'Yes');
            const hasAnyRowFilled = newDependents.some(row =>
                Object.values(row).some(v => String(v || '').trim() !== '')
            );

            if (allEmpty) {
                setHealthQuestionsValidity(prev => {
                    const updatedValidity = [...prev];
                    if (hasYesInGeneralQuestions && !hasAnyRowFilled) {
                        updatedValidity[index] = Object.fromEntries(
                            Object.keys(currentRow).map(key => [key, index === 0 ? false : true])
                        );
                        if (index !== 0) {
                            updatedValidity[0] = {
                                fullName: false,
                                medicalCondition: false,
                                prescriptionMedication: false,
                                dosage: false,
                                frequency: false,
                                dateOfOnset: false,
                            };
                        }
                    } else {
                        updatedValidity[index] = Object.fromEntries(
                            Object.keys(currentRow).map(key => [key, true])
                        );
                    }
                    return updatedValidity;
                });
            } else {
                // Some fields are filled → empty ones become required
                setHealthQuestionsValidity(prev => {
                    const updatedValidity = [...prev];
                    const newValidityRow = { ...updatedValidity[index] };

                    for (const [key, val] of Object.entries(currentRow)) {
                        newValidityRow[key] = val === '' ? false : true;
                    }

                    updatedValidity[index] = newValidityRow;
                    if (index !== 0) {
                        const firstRowEmpty = Object.values(newDependents[0]).every(v => String(v || '').trim() === '');
                        if (firstRowEmpty) {
                            updatedValidity[0] = {
                                fullName: true,
                                medicalCondition: true,
                                prescriptionMedication: true,
                                dosage: true,
                                frequency: true,
                                dateOfOnset: true,
                            };
                        }
                    }
                    return updatedValidity;
                });
            }


            return newDependents;
        })
    }


    // DISCLAIMER MODAL
    const [openDisclaimer, setOpenDisclaimer] = useState(false);
    const [agreeToTerms, setAgreeToTerms] = useState(false);
    const [legalTab, setLegalTab] = useState('comm');
    const [tcpaError, setTcpaError] = useState(false);

    const handleCloseDisclaimer = () => {
        setOpenDisclaimer(false);
        document.body.style.overflow = "auto";
        setAgreeToTerms(false);
        setTcpaError(false);
    }

    const handleOpenDisclaimer = () => {
        if (validateAnswers()) {
            setShowError(false);
            document.body.style.overflow = "hidden";
            setLegalTab('comm');
            setTcpaError(false);
            setOpenDisclaimer(true);
        } else {
            setShowError(true);
            setTimeout(() => {
                const firstInvalid = document.querySelector('[data-invalid="true"]');
                if (firstInvalid && typeof firstInvalid.scrollIntoView === 'function') {
                    firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
                } else {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                }
            }, 50);
        }
    }

    const handleAgreeToTerms = (e) => {
        const { name, type, checked } = e.target;

        if (type === 'checkbox' && (name === 'agreeToTerms' || name === 'tcpaConsent')) {
            setAgreeToTerms(checked);
            if (checked) {
                setTcpaError(false);
            }
        }
    }

    const handleDisclaimerSubmit = () => {
        if (!agreeToTerms) {
            setTcpaError(true);
            return;
        }
        handleFileUpload();
    };


    // Success Modal
    const [openModal, setOpenModal] = useState(false);

    const handleCloseModal = () => {
        document.body.style.overflow = "auto"
        setOpenModal(false)
        navigate('/')
    }

    const handleOpenModal = () => {
        document.body.style.overflow = "hidden"
        setOpenModal(true)

    }


    //Loading
    const [loading, setLoading] = useState(false);

    const handleLoading = () => {
        document.body.style.overflow = "hidden"
        setLoading(true)
    }


    const [showError, setShowError] = useState(false);
    const [validationErrorText, setValidationErrorText] = useState('Error! Some required fields are empty.');


    // Check Validation before submitting
    const validateAnswers = () => {
        let formIsValid = true;
        const missingList = [];
        const invalidList = [];

        const newPlansValidity = { ...plansValidity };
        const newPrimaryApplicantValidity = { ...primaryApplicantValidity };
        const newBankInfoValidity = { ...bankInfoValidity };
        const newGeneralQuestionsValidity = { ...generalQuestionsValidity };
        const newHealthQuestionsValidity = healthQuestionsValidity.map(row => ({ ...row }));
        const newPrimaryFormatValidity = {
            phoneNumber: true,
            zip: true,
            email: true,
            employerZip: true,
        };
        const newOptionalFieldsValidity = {
            primaryDoctorPhone: true,
            primaryDoctorZip: true,
            spouseSsn: true,
            spousePhone: true,
            spouseZip: true,
            spouseEmail: true,
            spouseEmployerZip: true,
            spouseDoctorPhone: true,
            spouseDoctorZip: true,
        };

        const planLabels = {
            desiredEffectiveDate: 'Desired Effective Date',
            healthPlan: 'Health Plan Selection',
            dentalPlan: 'Dental Plan Selection',
        };

        for (const key in plansData) {
            if (key === 'quotedMonthlyPremium' || key === 'deductible') {
                newPlansValidity[key] = true;
                continue;
            }
            const val = plansData[key] !== null && plansData[key] !== undefined ? String(plansData[key]).trim() : '';
            if (val === '') {
                formIsValid = false;
                newPlansValidity[key] = false;
                missingList.push(planLabels[key] || key);
            } else {
                newPlansValidity[key] = true;
            }
        }

        const primaryLabels = {
            lastName: 'Last Name',
            firstName: 'First Name',
            gender: 'Gender',
            ssn: 'Social Security Number',
            birthDate: 'Birth Date',
            age: 'Age',
            birthStateCounty: 'Birth State/County',
            homeAddress: 'Home Address',
            city: 'City',
            county: 'County',
            state: 'State',
            zip: 'Zip Code',
            phoneNumber: 'Phone Number',
            bestTimeToCall: 'Best Time To Call',
            heightFeet: 'Height (ft)',
            heightInch: 'Height (in)',
            weight: 'Weight',
            maritalStatus: 'Marital Status',
            email: 'Email Address',
            employerName: 'Employer Name',
            employerJob: 'Occupation / Job Title',
            employerAnnualIncome: 'Annual Income',
            employerAddress: 'Employer Address',
            employerCity: 'Employer City',
            employerState: 'Employer State',
            employerZip: 'Employer Zip',
        };

        for (const key in primaryApplicantData) {
            const val = primaryApplicantData[key] !== null && primaryApplicantData[key] !== undefined ? String(primaryApplicantData[key]).trim() : '';
            if (val === '') {
                formIsValid = false;
                newPrimaryApplicantValidity[key] = false;
                missingList.push(primaryLabels[key] || key);
            } else {
                newPrimaryApplicantValidity[key] = true;
            }
        }

        if (primaryApplicantDataNotRequired.howDidYouFindUs === 'Referral') {
            if (String(primaryApplicantDataNotRequired.referredBy || '').trim() === '') {
                formIsValid = false;
                newPrimaryApplicantValidity.referredBy = false;
                missingList.push('Referred By');
            } else {
                newPrimaryApplicantValidity.referredBy = true;
            }
        } else {
            newPrimaryApplicantValidity.referredBy = true;
        }

        const parsedPrimaryAge = parseInt(String(primaryApplicantData.age || '').trim(), 10);
        if (primaryApplicantData.age && (isNaN(parsedPrimaryAge) || parsedPrimaryAge < 18 || parsedPrimaryAge > 64)) {
            formIsValid = false;
            newPrimaryApplicantValidity.age = false;
            invalidList.push('Primary Age (must be 18–64)');
        } else if (primaryApplicantData.birthDate && !isNaN(parsedPrimaryAge)) {
            const birthDateAge = calcBirthToAge(primaryApplicantData.birthDate);
            if (birthDateAge !== parsedPrimaryAge) {
                formIsValid = false;
                newPrimaryApplicantValidity.birthDate = false;
                invalidList.push(`Primary Birth Date (must match Age ${parsedPrimaryAge})`);
            }
        }

        if (primaryApplicantData.ssn && primaryApplicantData.ssn.length !== 9) {
            formIsValid = false;
            newPrimaryApplicantValidity.ssn = false;
            setSsnMinMaxValidity(false);
            invalidList.push('Primary SSN (must be 9 digits)');
        } else {
            setSsnMinMaxValidity(true);
        }

        if (primaryApplicantData.phoneNumber && !validatePhone(primaryApplicantData.phoneNumber)) {
            formIsValid = false;
            newPrimaryApplicantValidity.phoneNumber = false;
            newPrimaryFormatValidity.phoneNumber = false;
            invalidList.push('Primary Phone Number');
        } else if (!primaryApplicantData.phoneNumber) {
            newPrimaryApplicantValidity.phoneNumber = false;
        }

        if (primaryApplicantData.zip && !validateZip(primaryApplicantData.zip)) {
            formIsValid = false;
            newPrimaryApplicantValidity.zip = false;
            newPrimaryFormatValidity.zip = false;
            invalidList.push('Primary Zip Code');
        } else if (!primaryApplicantData.zip) {
            newPrimaryApplicantValidity.zip = false;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (primaryApplicantData.email && !emailRegex.test(String(primaryApplicantData.email).trim())) {
            formIsValid = false;
            newPrimaryApplicantValidity.email = false;
            newPrimaryFormatValidity.email = false;
            invalidList.push('Primary Email Address');
        }

        if (primaryApplicantData.employerZip && !validateZip(primaryApplicantData.employerZip)) {
            formIsValid = false;
            newPrimaryApplicantValidity.employerZip = false;
            newPrimaryFormatValidity.employerZip = false;
            invalidList.push('Employer Zip Code');
        }

        if (primaryApplicantDataNotRequired.doctorPhone && !validatePhone(primaryApplicantDataNotRequired.doctorPhone)) {
            formIsValid = false;
            newOptionalFieldsValidity.primaryDoctorPhone = false;
            invalidList.push("Primary Doctor's Phone");
        }
        if (primaryApplicantDataNotRequired.doctorZip && !validateZip(primaryApplicantDataNotRequired.doctorZip)) {
            formIsValid = false;
            newOptionalFieldsValidity.primaryDoctorZip = false;
            invalidList.push("Primary Doctor's Zip");
        }
        if (spouseData.ssn && spouseData.ssn.length !== 9) {
            formIsValid = false;
            newOptionalFieldsValidity.spouseSsn = false;
            invalidList.push('Spouse SSN (must be 9 digits)');
        }
        if (spouseData.phoneNumber && !validatePhone(spouseData.phoneNumber)) {
            formIsValid = false;
            newOptionalFieldsValidity.spousePhone = false;
            invalidList.push('Spouse Phone Number');
        }
        if (spouseData.zip && !validateZip(spouseData.zip)) {
            formIsValid = false;
            newOptionalFieldsValidity.spouseZip = false;
            invalidList.push('Spouse Zip Code');
        }
        if (spouseData.email && !emailRegex.test(String(spouseData.email).trim())) {
            formIsValid = false;
            newOptionalFieldsValidity.spouseEmail = false;
            invalidList.push('Spouse Email Address');
        }
        if (spouseData.employerZip && !validateZip(spouseData.employerZip)) {
            formIsValid = false;
            newOptionalFieldsValidity.spouseEmployerZip = false;
            invalidList.push('Spouse Employer Zip');
        }
        if (spouseData.doctorPhone && !validatePhone(spouseData.doctorPhone)) {
            formIsValid = false;
            newOptionalFieldsValidity.spouseDoctorPhone = false;
            invalidList.push("Spouse Doctor's Phone");
        }
        if (spouseData.doctorZip && !validateZip(spouseData.doctorZip)) {
            formIsValid = false;
            newOptionalFieldsValidity.spouseDoctorZip = false;
            invalidList.push("Spouse Doctor's Zip");
        }

        // Page 2
        if (anyTobaccoProducts.anyTobaccoPrimary === '') {
            formIsValid = false;
            setAnyTobaccoProductsValidity(false);
            missingList.push('Any Tobacco Products (Primary)');
        } else {
            setAnyTobaccoProductsValidity(true);
        }

        if (useTobaccoLastTwoYears.usedTobaccoPrimary === '') {
            formIsValid = false;
            setUseTobaccoLastTwoYearsValidity(false);
            missingList.push('Used Tobacco Last 24 Months (Primary)');
        } else {
            setUseTobaccoLastTwoYearsValidity(true);
        }

        let missingQuestionsCount = 0;
        for (const key in generalQuestions) {
            if (generalQuestions[key] === '') {
                formIsValid = false;
                newGeneralQuestionsValidity[key] = false;
                missingQuestionsCount++;
            } else {
                newGeneralQuestionsValidity[key] = true;
            }
        }
        if (missingQuestionsCount > 0) {
            missingList.push(`Health Questions (${missingQuestionsCount} unanswered)`);
        }

        const hasYesInGeneralQuestions = Object.values(generalQuestions).some(val => val === 'Yes');
        const hasAnyHealthRowFilled = healthQuestions.some(row =>
            Object.values(row).some(value => String(value || '').trim() !== '')
        );
        let healthDetailsError = false;
        const healthColLabels = {
            fullName: 'Name',
            medicalCondition: 'Medical Condition',
            prescriptionMedication: 'Prescription Medication Name',
            dosage: 'Dosage',
            frequency: 'Frequency',
            dateOfOnset: 'Date of Onset',
        };

        for (let i = 0; i < healthQuestions.length; i++) {
            const row = healthQuestions[i];
            const allEmpty = Object.values(row).every(value => String(value || '').trim() === '');

            if (allEmpty) {
                if (i === 0 && hasYesInGeneralQuestions && !hasAnyHealthRowFilled) {
                    formIsValid = false;
                    healthDetailsError = true;
                    newHealthQuestionsValidity[0] = {
                        fullName: false,
                        medicalCondition: false,
                        prescriptionMedication: false,
                        dosage: false,
                        frequency: false,
                        dateOfOnset: false,
                    };
                    missingList.push('Proposed Insured Health Details (Row 1)');
                } else {
                    newHealthQuestionsValidity[i] = {
                        fullName: true,
                        medicalCondition: true,
                        prescriptionMedication: true,
                        dosage: true,
                        frequency: true,
                        dateOfOnset: true,
                    };
                }
            } else {
                const missingCols = [];
                for (const [colKey, colVal] of Object.entries(row)) {
                    const isColValid = String(colVal || '').trim() !== '';
                    newHealthQuestionsValidity[i][colKey] = isColValid;
                    if (!isColValid) {
                        formIsValid = false;
                        missingCols.push(healthColLabels[colKey] || colKey);
                    }
                }
                if (missingCols.length > 0) {
                    if (hasYesInGeneralQuestions) {
                        healthDetailsError = true;
                    }
                    missingList.push(`Health Details Row ${i + 1} (${missingCols.join(', ')})`);
                }
            }
        }

        const bankLabels = {
            bankInstitution: 'Bank / Financial Institution',
            routingNumber: 'Routing Number',
            accountNumber: 'Account Number',
            accountHolderName: 'Account Holder Name(s)',
        };

        for (const key in bankInfo) {
            const val = bankInfo[key] !== null && bankInfo[key] !== undefined ? String(bankInfo[key]).trim() : '';
            if (val === '') {
                formIsValid = false;
                newBankInfoValidity[key] = false;
                missingList.push(bankLabels[key] || key);
            } else {
                newBankInfoValidity[key] = true;
            }
        }

        if (bankInfo.routingNumber && bankInfo.routingNumber.length !== 9) {
            formIsValid = false;
            newBankInfoValidity.routingNumber = false;
            setRouteNumberMinMaxValidity(false);
            invalidList.push('Routing Number (must be 9 digits)');
        } else {
            setRouteNumberMinMaxValidity(true);
        }

        if (image === null) {
            formIsValid = false;
            setImageValidity(false);
            missingList.push('Account Holder E-Signature');
        } else {
            setImageValidity(true);
        }

        if (image2 === null) {
            formIsValid = false;
            setImage2Validity(false);
            missingList.push('Applicant E-Signature');
        } else {
            setImage2Validity(true);
        }

        if (!applicantSignatureDate.date || String(applicantSignatureDate.date).trim() === '') {
            formIsValid = false;
            setApplicantSignatureDate(prevState => ({
                ...prevState,
                validity: false
            }));
            missingList.push('Applicant Signature Date');
        } else {
            setApplicantSignatureDate(prevState => ({
                ...prevState,
                validity: true
            }));
        }

        setPlansValidity(newPlansValidity);
        setPrimaryApplicantValidity(newPrimaryApplicantValidity);
        setPrimaryFormatValidity(newPrimaryFormatValidity);
        setOptionalFieldsValidity(newOptionalFieldsValidity);
        setGeneralQuestionsValidity(newGeneralQuestionsValidity);
        setHealthQuestionsValidity(newHealthQuestionsValidity);
        setBankInfoValidity(newBankInfoValidity);

        setIsValid(formIsValid);

        if (!formIsValid) {
            const parts = [];
            if (missingList.length > 0) {
                const preview = missingList.slice(0, 4).join(', ');
                const extra = missingList.length > 4 ? ` (+${missingList.length - 4} more)` : '';
                parts.push(`Missing required fields: ${preview}${extra}.`);
            }
            if (healthDetailsError && !missingList.slice(0, 4).some(item => item.includes('Health Details'))) {
                parts.push('At least 1 complete row in Proposed Insured Health Details is required when YES is answered in General & Health Questions.');
            }
            if (invalidList.length > 0) {
                const preview = invalidList.slice(0, 4).join(', ');
                const extra = invalidList.length > 4 ? ` (+${invalidList.length - 4} more)` : '';
                parts.push(`Invalid format: ${preview}${extra}.`);
            }
            setValidationErrorText(`Error! ${parts.join(' ')}`);
        }

        return formIsValid
    }



    const firstPageRef = useRef(null);
    const secondPageRef = useRef(null);


    const setupDocument = async () => {
        console.log();
        setSending(true)

        await fakeDelay(5000);

        console.log();
        const formData = new FormData();
        const printedDoc = await printDocument(firstPageRef, secondPageRef);

        formData.append('file', printedDoc, `EnrollmentForm-${primaryApplicantData.lastName}${primaryApplicantData.firstName.replaceAll(' ', '')}.pdf`);
        formData.append('userEmail', primaryApplicantData.email);

        return formData;
    }

    const [scale, setScale] = useState(100);


    // CONVERT TO PDF AND UPLOAD DOCUMENT
    const handleFileUpload = async () => {
        setScale(100);
        handleLoading();
        setSent(false);
        setShowErrorMessage(false);
        setStyledInput({ border: '0px' });

        // Initialize webhook data structure
        const deviceData = getDeviceFingerprint();
        const dataForGHL = {
            webViewLink: null, // Initialize as null
            webContentLink: null, // Initialize as null
            userEmail: primaryApplicantData.email,
            userFirstName: primaryApplicantData.firstName,
            tcpaConsent: true,
            tcpaConsentCaptured: true,
            tcpaConsentTimestamp: new Date().toISOString(),
            exactDisclaimerText: TCPA_ENROLLMENT_DISCLAIMER,
            ...deviceData
        };

        try {
            await withSubmissionTimeout(async () => {
                // Note: ensure setupDocument() handles file validation and returns the file object
                const file = await setupDocument();
                const response = await postWP("custom/v1/upload", file);

                // 1. HARDENED CHECK: Ensure the backend confirms success AND provides the link.
                if (response && response.success && response.link) {
                    dataForGHL.webViewLink = response.link;

                    const accountID = await getAccountID();
                    const webhookID = await getWebhookID({ formName: "enroll" });

                    await sendToGHL(dataForGHL, accountID, webhookID);
                } else {
                    throw new Error(response?.message || "Upload failed or link missing.");
                }
            });

            localStorage.removeItem('quoteForm');
            localStorage.removeItem('priceQuote');

            // Success UI Updates
            setStyledInput({ border: '1px solid rgba(0,0,0,0.2)' });
            setSent(true);
            handleCloseDisclaimer();
            handleOpenModal();

        } catch (error) {
            console.error('Error submitting enrollment form:', error);
            setErrorMessage(getSubmissionErrorMessage(error));
            setShowErrorMessage(true);
            handleCloseDisclaimer();
        }
        // --- Final Cleanup ---
        finally {
            // Ensure cleanup happens even if exceptions are thrown
            setSending(false);
            setLoading(false);
            setSent(true);
            setStyledInput({ border: '1px solid rgba(0,0,0,0.2)' }); // Restore border if needed
        }
    };



    useEffect(() => {
        const savedQuoteData = getLocalStorage('quoteForm');
        const savedQuotePriceData = getLocalStorage('priceQuote');
        if (savedQuoteData) {
            const quoteData = JSON.parse(savedQuoteData);
            const normalizedGender =
                quoteData.gender && String(quoteData.gender).toLowerCase() === 'male'
                    ? 'Male'
                    : quoteData.gender && String(quoteData.gender).toLowerCase() === 'female'
                        ? 'Female'
                        : quoteData.gender || '';
            const formattedPhone = formatPhoneNumber(quoteData.phone || '');
            const formattedZip = formatZipCode(quoteData.zipCode || '');
            const ageStr = quoteData.age !== null && quoteData.age !== undefined ? String(quoteData.age).trim() : '';

            setPrimaryApplicantData(prev => ({
                ...prev,
                lastName: quoteData.lastName || '',
                firstName: quoteData.firstName || '',
                email: quoteData.email || '',
                gender: normalizedGender,
                age: ageStr,
                state: quoteData.state || '',
                phoneNumber: formattedPhone,
                zip: formattedZip,
            }));
            setLockedQuoteFields(prev => ({
                ...prev,
                age: ageStr !== '',
            }));
        } else {
            setLockedQuoteFields(prev => ({
                ...prev,
                age: false,
            }));
        }

        if (savedQuotePriceData) {
            const quotePriceData = JSON.parse(savedQuotePriceData);
            const priceStr = quotePriceData.priceQuote !== null && quotePriceData.priceQuote !== undefined ? String(quotePriceData.priceQuote).trim() : '';
            const planStr = quotePriceData.healthPlan ? String(quotePriceData.healthPlan).toLowerCase() : '';
            setPlansData(prev => ({
                ...prev,
                quotedMonthlyPremium: priceStr,
                deductible: '2500',
                healthPlan: planStr
            }));
            setLockedQuoteFields(prev => ({
                ...prev,
                isFromQuote: true,
                healthPlan: planStr === 'silver' || planStr === 'gold',
            }));
        } else {
            setPlansData(prev => ({
                ...prev,
                quotedMonthlyPremium: '',
                deductible: ''
            }));
            setLockedQuoteFields(prev => ({
                ...prev,
                isFromQuote: Boolean(savedQuoteData),
                healthPlan: false,
            }));
        }

    }, []);







    const [scaledPDF, setScaledPDF] = useState(816);

    const zoomIn = () => {
        const nextScale = scale + 5;
        const scaled = scaledPDF * (nextScale / scale); // relative scaling
        const viewportWidth = window.innerWidth;

        if (scaled < viewportWidth) {
            setScale(nextScale);
            setScaledPDF(scaled);
        }
    };

    const zoomOut = () => {
        if (scale > 100) {
            const nextScale = scale - 5;
            const scaled = scaledPDF * (nextScale / scale); // relative scaling
            setScale(nextScale);
            setScaledPDF(scaled);
        }
    };


    const reset = () => {
        setScale(100);
        setScaledPDF(816)
    }

    useEffect(() => {
        const sticky = document.getElementById('stickyTarget');
        const parent = sticky.parentElement;

        const handleScroll = () => {
            const parentRect = parent.getBoundingClientRect();
            const stickyHeight = sticky.offsetHeight;

            if (parentRect.bottom <= window.innerHeight + stickyHeight) {
                sticky.classList.remove('opacity-100');
                // sticky.classList.add('absolute');
                sticky.classList.add('opacity-0');
            } else {
                sticky.classList.remove('opacity-0');
                // sticky.classList.add('fixed');
                sticky.classList.add('opacity-100');
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);








    // SIGNATURES
    // Account Holder Signature
    const [openModal1, setOpenModal1] = useState(false);
    const [signHereShow, setSignHereShow] = useState(false);
    const [sign, setSign] = useState();

    const handleSignHereShow = () => {
        setSignHereShow(true)
    }

    const handleCancel = () => {
        setSignHereShow(false)
    }

    const handleOpenModal1 = () => {
        setOpenModal1(true)
    }

    const handleClear = () => {
        sign.clear()
    }

    const handleSignature = () => {
        if (!sign || sign.isEmpty()) {
            setImage(null);
            setImageValidity(false);
            setSignHereShow(false);
            setOpenModal1(false);
            return;
        }
        setShowError(false);
        setImageValidity(true);
        setImage(sign.getTrimmedCanvas().toDataURL('image/png'));
        setSignHereShow(false);
        setOpenModal1(false);
        sign.clear();
    }


    // Primary Applicant Signature
    const [openModal2, setOpenModal2] = useState(false);
    const [signHere2Show, setSignHere2Show] = useState(false);
    const [sign2, setSign2] = useState();

    const handleSignHere2Show = () => {
        setSignHere2Show(true)
    }

    const handleCancel2 = () => {
        setSignHere2Show(false)
    }

    const handleOpenModal2 = () => {
        setOpenModal2(true)
    }

    const handleClear2 = () => {
        sign2.clear()
    }

    const handleSignature2 = () => {
        if (!sign2 || sign2.isEmpty()) {
            setImage2(null);
            setImage2Validity(false);
            setSignHere2Show(false);
            setOpenModal2(false);
            return;
        }
        setShowError(false);
        setImage2Validity(true);
        setImage2(sign2.getTrimmedCanvas().toDataURL('image/png'));
        setSignHere2Show(false);
        setOpenModal2(false);
        sign2.clear();
    }



    // Spouse Signature
    const [openModal3, setOpenModal3] = useState(false);
    const [signHere3Show, setSignHere3Show] = useState(false);
    const [sign3, setSign3] = useState();

    const handleSignHere3Show = () => {
        setSignHere3Show(true)
    }

    const handleCancel3 = () => {
        setSignHere3Show(false)
    }

    const handleOpenModal3 = () => {
        setOpenModal3(true)
    }

    const handleClear3 = () => {
        sign3.clear()
    }

    const handleSignature3 = () => {
        setImage3(sign3.getTrimmedCanvas().toDataURL('image/png'))
        setSignHere3Show(false)
        setOpenModal3(false)
        sign3.clear()
    }


    return (
        <>

            <AlertError showError={showErrorMessage} onClose={() => setShowErrorMessage(false)}>
                {errorMessage || 'Something went wrong. Please try again later.'}
            </AlertError>

            <div className={`relative overflow-auto border-y my-8`}>
                <div style={{ transform: `scale(${scale / 100})` }} className='duration-300 transition-all origin-top-left md:origin-top'>
                    <div className='space-y-10 px-4 py-7 flex flex-col items-start md:items-center'>
                        <Page1
                            firstPageRef={firstPageRef}
                            sending={sending}
                            styledInput={styledInput}
                            styledDisabledInput={styledDisabledInput}
                            lockedQuoteFields={lockedQuoteFields}
                            isValid={isValid}
                            styledNotValid={styledNotValid}
                            plansData={plansData}
                            plansValidity={plansValidity}
                            handlePlansDataChange={handlePlansDataChange}
                            primaryApplicantData={primaryApplicantData}
                            primaryApplicantValidity={primaryApplicantValidity}
                            primaryFormatValidity={primaryFormatValidity}
                            optionalFieldsValidity={optionalFieldsValidity}
                            primaryApplicantDataNotRequired={primaryApplicantDataNotRequired}
                            handlePrimaryApplicantDataNotRequired={handlePrimaryApplicantDataNotRequired}
                            handlePrimaryApplicantChange={handlePrimaryApplicantChange}
                            spouseData={spouseData}
                            handleSpouseChange={handleSpouseChange}
                            dependents={dependents}
                            handleDependentsChange={handleDependentsChange}
                            ssnMinMaxValidity={ssnMinMaxValidity}
                            displayedDateFormats={displayedDateFormats}
                        />
                        <Page2
                            secondPageRef={secondPageRef}
                            sending={sending}
                            styledInput={styledInput}
                            styledNotValid={styledNotValid}
                            isValid={isValid}
                            image={image}
                            imageValidity={imageValidity}
                            handleImageUpload={handleImageUpload}
                            image2={image2}
                            image2Validity={image2Validity}
                            handleImage2Upload={handleImage2Upload}
                            image3={image3}
                            image3Validity={image3Validity}
                            setImage={setImage}
                            setImage2={setImage2}
                            setImage3={setImage3}
                            anyTobaccoProductsValidity={anyTobaccoProductsValidity}
                            useTobaccoLastTwoYearsValidity={useTobaccoLastTwoYearsValidity}
                            handleGeneralQuestionsChange={handleGeneralQuestionsChange}
                            handleAnyTobaccoProductsChange={handleAnyTobaccoProductsChange}
                            handleUseTobaccoLastTwoYearsChange={handleUseTobaccoLastTwoYearsChange}
                            generalQuestionsAnswers={generalQuestions}
                            generalQuestionsValidity={generalQuestionsValidity}
                            handleImage3Upload={handleImage3Upload}
                            setImageValidity={setImageValidity}
                            setImage2Validity={setImage2Validity}
                            bankInfo={bankInfo}
                            bankInfoValidity={bankInfoValidity}
                            handleBankInfoChange={handleBankInfoChange}
                            applicantSignatureDate={applicantSignatureDate}
                            handleApplicantSignatureDate={handleApplicantSignatureDate}
                            spouseSignatureDate={spouseSignatureDate}
                            handlSpouseSignatureDateChange={handlSpouseSignatureDateChange}
                            routeNumberMinMaxValidity={routeNumberMinMaxValidity}
                            displayedDateFormats={displayedDateFormats}
                            setDisplayedDateFormats={setDisplayedDateFormats}
                            formatDate={formatDate}


                            handleOpenModal1={handleOpenModal1}
                            handleOpenModal2={handleOpenModal2}
                            handleOpenModal3={handleOpenModal3}

                            healthQuestions={healthQuestions}
                            healthQuestionsValidity={healthQuestionsValidity}
                            handleForm2Change={handleForm2Change}
                        />
                    </div>
                </div>

                <div id='stickyTarget' className='fixed bottom-4 left-1/2 -translate-x-1/2 my-4 hidden md:flex justify-center space-x-2 transition-all ease-in-out duration-300'>
                    <button className='btn btn-primary' onClick={zoomIn}>
                        <svg className="w-6 h-6 text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                            <path stroke="currentColor" strokeLinecap="round" strokeWidth="2" d="m21 21-3.5-3.5M10 7v6m-3-3h6m4 0a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z" />
                        </svg>
                    </button>
                    <button className='btn btn-primary' onClick={zoomOut}>
                        <svg className="w-6 h-6 text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                            <path stroke="currentColor" strokeLinecap="round" strokeWidth="2" d="m21 21-3.5-3.5M7 10h6m4 0a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z" />
                        </svg>

                    </button>
                    <button className='btn btn-primary text-white' onClick={reset}>Reset</button>
                </div>
            </div>


            <div className='flex justify-center'>
                <div className='my-10 w-[816px] flex flex-col justify-center space-y-4 mx-4 md:space-y-0 md:flex-row md:justify-between'>
                    <button onClick={() => navigate(-1)} disabled={sent ? false : true} className='btn btn-lg btn-outline px-10 text-lg'>Back</button>
                    <button onClick={handleOpenDisclaimer} disabled={sent ? false : true} className='btn btn-lg btn-secondary px-10 text-white text-lg'>Submit</button>
                </div>
            </div>




            {/* Account Holder Signature */}
            <Modal open={openModal1} handleClose={() => { setOpenModal1(false); setSignHereShow(false); }}>
                <div className='text-center text-3xl'>Account Holder Signature</div>

                {
                    signHereShow ?
                        <div className='flex flex-col items-center justify-center p-2'>
                            <div className='text-center'>Draw a signature</div>
                            <div style={{ ...styledInput, width: 400, height: 200 }} className='bg-white mx-1 flex flex-col justify-center items-center z-50'>
                                <ReactSignatureCanvas
                                    canvasProps={{ width: 400, height: 200 }}
                                    ref={data => setSign(data)}
                                />
                                <button className='border border-gray-500 px-3 py-[2px] bg-white flex' onClick={handleClear}><span><CiEraser className='text-[12px]' /></span>Clear</button>
                            </div>
                            <div className='flex justify-evenly w-full mt-5'>
                                <button className='btn px-7 btn-error text-white' onClick={handleCancel}>Cancel</button>
                                <button className='btn px-7 btn-secondary text-white' onClick={handleSignature}>Confirm</button>
                            </div>
                        </div>
                        :
                        <div className='flex flex-col sm:flex-row gap-2 justify-evenly mt-5'>
                            <button className='btn' onClick={() => { document.getElementById('fileInput').click(); setOpenModal1(false) }}>
                                <span><RiFolderUploadFill className='text-lg' /></span>
                                Upload E-Signature
                            </button>
                            <button className='btn px-7' onClick={handleSignHereShow}>
                                <span><FaFileSignature className='text-lg' /></span>
                                Sign here
                            </button>
                        </div>
                }
            </Modal>


            {/* Primary Applicant Signature */}
            <Modal open={openModal2} handleClose={() => setOpenModal2(false)}>
                <div className='text-center text-3xl'>Primary Applicant Signature</div>

                {
                    signHere2Show ?
                        <div className='flex flex-col items-center justify-center p-2'>
                            <div className='text-center'>Draw a signature</div>
                            <div style={{ ...styledInput, width: 500, height: 200 }} className='bg-white mx-1 flex flex-col justify-center items-center z-50'>
                                <ReactSignatureCanvas
                                    canvasProps={{ width: 500, height: 200 }}
                                    ref={data => setSign2(data)}
                                />
                                <button className='border border-gray-500 px-3 py-[2px] bg-white flex' onClick={handleClear2}><span><CiEraser className='text-[12px]' /></span>Clear</button>
                            </div>
                            <div className='flex justify-evenly w-full mt-5'>
                                <button className='btn px-7 btn-error text-white' onClick={handleCancel2}>Cancel</button>
                                <button className='btn px-7 btn-secondary text-white' onClick={handleSignature2}>Confirm</button>
                            </div>
                        </div>
                        :
                        <div className='flex justify-evenly mt-5'>
                            <button className='btn' onClick={() => { document.getElementById('fileInput2').click(); setOpenModal2(false) }}>
                                <span><RiFolderUploadFill className='text-lg' /></span>
                                Upload E-Signature
                            </button>
                            <button className='btn px-7' onClick={handleSignHere2Show}>
                                <span><FaFileSignature className='text-lg' /></span>
                                Sign here
                            </button>
                        </div>
                }
            </Modal>


            {/* Spouse Signature */}
            <Modal open={openModal3} handleClose={() => setOpenModal3(false)} >
                <div className='text-center text-3xl'>Spouse Signature</div>

                {
                    signHere3Show ?
                        <div className='flex flex-col items-center justify-center p-2'>
                            <div className='text-center'>Draw a signature</div>
                            <div style={{ ...styledInput, width: 500, height: 200 }} className='bg-white mx-1 flex flex-col justify-center items-center z-50'>
                                <ReactSignatureCanvas
                                    canvasProps={{ width: 500, height: 200 }}
                                    ref={data => setSign3(data)}
                                />
                                <button className='border border-gray-500 px-3 py-[2px] bg-white flex' onClick={handleClear3}><span><CiEraser className='text-[12px]' /></span>Clear</button>
                            </div>
                            <div className='flex justify-evenly w-full mt-5'>
                                <button className='btn px-7 btn-error text-white' onClick={handleCancel3}>Cancel</button>
                                <button className='btn px-7 btn-secondary text-white' onClick={handleSignature3}>Confirm</button>
                            </div>
                        </div>
                        :
                        <div className='flex justify-evenly mt-5'>
                            <button className='btn' onClick={() => { document.getElementById('fileInput3').click(); setOpenModal3(false) }}>
                                <span><RiFolderUploadFill className='text-lg' /></span>
                                Upload E-Signature
                            </button>
                            <button className='btn px-7' onClick={handleSignHere3Show}>
                                <span><FaFileSignature className='text-lg' /></span>
                                Sign here
                            </button>
                        </div>
                }
            </Modal>

            {/* Unified 3-Tab Legal / TCPA Modal */}
            <Modal
                open={openDisclaimer}
                handleClose={handleCloseDisclaimer}
                closeButton={false}
                disableBackgroundClose={true}
                maxWidth="sm:max-w-lg"
            >
                <div className="p-4 sm:p-5 space-y-3 text-left w-full mt-[-24px] sm:mt-[-30px]">
                    {/* Header */}
                    <div className="border-b border-base-200 pb-2">
                        <h3 className="text-sm sm:text-base font-bold text-base-content">
                            Agreements &amp; Disclosures
                        </h3>
                    </div>

                    {/* 3 Tabs Bar */}
                    <div className="flex border-b border-base-200 gap-1 sm:gap-2">
                        <button
                            type="button"
                            onClick={() => setLegalTab('comm')}
                            className={`py-1.5 px-2.5 sm:px-3 text-xs font-bold transition-all rounded-t-lg border-b-2 ${
                                legalTab === 'comm'
                                    ? 'border-primary text-primary bg-primary/10'
                                    : 'border-transparent text-base-content/70 hover:text-base-content hover:bg-base-200/50'
                            }`}
                        >
                            Communication Agreement
                        </button>
                        <button
                            type="button"
                            onClick={() => setLegalTab('terms')}
                            className={`py-1.5 px-2.5 sm:px-3 text-xs font-bold transition-all rounded-t-lg border-b-2 ${
                                legalTab === 'terms'
                                    ? 'border-primary text-primary bg-primary/10'
                                    : 'border-transparent text-base-content/70 hover:text-base-content hover:bg-base-200/50'
                            }`}
                        >
                            Terms &amp; Conditions
                        </button>
                        <button
                            type="button"
                            onClick={() => setLegalTab('privacy')}
                            className={`py-1.5 px-2.5 sm:px-3 text-xs font-bold transition-all rounded-t-lg border-b-2 ${
                                legalTab === 'privacy'
                                    ? 'border-primary text-primary bg-primary/10'
                                    : 'border-transparent text-base-content/70 hover:text-base-content hover:bg-base-200/50'
                            }`}
                        >
                            Privacy Policy
                        </button>
                    </div>

                    {/* Scrollable Tab Content Container */}
                    <div className="modal-legal-content max-h-[200px] overflow-y-auto pr-2 text-[10px] text-base-content/85 leading-snug bg-base-200/30 p-2.5 sm:p-3 rounded-xl border border-base-200">
                        {legalTab === 'terms' && (
                            <div className="space-y-3">
                                <TermsAndConditionContent />
                            </div>
                        )}

                        {legalTab === 'privacy' && (
                            <div className="space-y-3">
                                <PrivacyPolicyContent />
                            </div>
                        )}

                        {legalTab === 'comm' && (
                            <div className="space-y-2.5">
                                <div className="border-b border-base-200 pb-1">
                                    <h4 className="text-xs font-bold text-base-content">
                                        Electronic Communications Agreement &amp; TCPA Consent
                                    </h4>
                                    <p className="text-[9px] text-base-content/60">
                                        Effective Date: August 4, 2026 • insuranceenterpriseusa.com
                                    </p>
                                </div>

                                <p className="text-[10px] leading-relaxed">
                                    By submitting your contact information (including your phone number and email address) through any online quote form, health plan calculator, enrollment form, or inquiry portal on this Site, you provide your express written consent and agreement to the following terms:
                                </p>

                                <div className="space-y-2 text-[9.5px] sm:text-[10px] leading-snug">
                                    <div>
                                        <h5 className="font-bold text-base-content text-[10px] sm:text-[10.5px]">1. Express Written Consent</h5>
                                        <p className="text-base-content/80 mt-0.5">
                                            You authorize Insurance Enterprise USA, its licensed agents, affiliates, and representatives to contact you regarding health insurance quotes, plan options, coverage details, and related insurance services via telephone calls, SMS/MMS text messages, and email at the phone number and email address provided.
                                        </p>
                                    </div>

                                    <div>
                                        <h5 className="font-bold text-base-content text-[10px] sm:text-[10.5px]">2. Automated Technology</h5>
                                        <p className="text-base-content/80 mt-0.5">
                                            You understand and agree that communications may be transmitted using automated telephone dialing systems (ATDS), artificial or prerecorded voice messages, automated SMS systems, and computer-generated emails.
                                        </p>
                                    </div>

                                    <div>
                                        <h5 className="font-bold text-base-content text-[10px] sm:text-[10.5px]">3. Consent Not Required for Purchase</h5>
                                        <p className="text-base-content/80 mt-0.5">
                                            Your consent to receive promotional and informational communications is completely voluntary and is <strong>not a condition of purchasing</strong> any goods, services, or insurance policies from Insurance Enterprise USA.
                                        </p>
                                    </div>

                                    <div>
                                        <h5 className="font-bold text-base-content text-[10px] sm:text-[10.5px]">4. Message Frequency &amp; Carrier Rates</h5>
                                        <p className="text-base-content/80 mt-0.5">
                                            Message frequency varies depending on your inquiries and active requests. Standard message and data rates charged by your mobile wireless carrier may apply to all SMS/MMS messages.
                                        </p>
                                    </div>

                                    <div>
                                        <h5 className="font-bold text-base-content text-[10px] sm:text-[10.5px]">5. Opt-Out &amp; Revocation of Consent</h5>
                                        <p className="text-base-content/80 mt-0.5">
                                            You may revoke your consent or opt out at any time. To stop receiving text messages, reply <strong>STOP</strong> to any SMS received. To request help, reply <strong>HELP</strong>. To unsubscribe from emails, click the unsubscribe link at the bottom of any email. You may also contact our compliance department at <span className="font-bold text-primary">888-350-6605</span> or via email at <span className="font-bold text-primary">enroll@insuranceenterpriseusa.com</span>.
                                        </p>
                                    </div>

                                    <div>
                                        <h5 className="font-bold text-base-content text-[10px] sm:text-[10.5px]">6. E-SIGN Disclosure</h5>
                                        <p className="text-base-content/80 mt-0.5">
                                            You consent to receive all notices, policy documents, disclosures, and communications electronically pursuant to the Electronic Signatures in Global and National Commerce Act (E-SIGN Act).
                                        </p>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Mandatory TCPA Checkbox (Distinct Grayish Container) */}
                    <div className="bg-slate-100 dark:bg-base-200/60 p-2.5 rounded-xl border border-slate-200 dark:border-base-300">
                        <label className="label cursor-pointer flex items-start space-x-2 p-0">
                            <input
                                type="checkbox"
                                disabled={loading}
                                name="tcpaConsent"
                                checked={agreeToTerms}
                                onChange={handleAgreeToTerms}
                                className={`checkbox checkbox-primary checkbox-xs rounded mt-0.5 shrink-0 ${
                                    tcpaError ? 'checkbox-error' : ''
                                }`}
                            />
                            <span className="label-text text-[9.5px] sm:text-[10px] leading-snug text-slate-500 dark:text-base-content/65">
                                I agree to the{' '}
                                <button
                                    type="button"
                                    disabled={loading}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        setLegalTab('terms');
                                    }}
                                    className="underline font-bold text-slate-700 dark:text-base-content/85 hover:text-primary cursor-pointer inline text-left bg-transparent border-0 p-0 text-[9.5px] sm:text-[10px]"
                                >
                                    Terms &amp; Conditions
                                </button>
                                ,{' '}
                                <button
                                    type="button"
                                    disabled={loading}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        setLegalTab('privacy');
                                    }}
                                    className="underline font-bold text-slate-700 dark:text-base-content/85 hover:text-primary cursor-pointer inline text-left bg-transparent border-0 p-0 text-[9.5px] sm:text-[10px]"
                                >
                                    Privacy Policy
                                </button>
                                , and{' '}
                                <button
                                    type="button"
                                    disabled={loading}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        setLegalTab('comm');
                                    }}
                                    className="underline font-bold text-slate-700 dark:text-base-content/85 hover:text-primary cursor-pointer inline text-left bg-transparent border-0 p-0 text-[9.5px] sm:text-[10px]"
                                >
                                    Communication Agreement
                                </button>
                                . By checking this box and clicking "Submit Enrollment", I provide my express written consent for Insurance Enterprise USA to contact me regarding health insurance options via email, phone calls, and text messages at the number provided above, including automated technology. <strong className="text-slate-700 dark:text-base-content/90 font-semibold">Consent is not a condition of purchase.</strong>
                            </span>
                        </label>
                        {tcpaError && (
                            <span className="text-[10px] text-error mt-1.5 block font-semibold">
                                Please check the agreement box to proceed.
                            </span>
                        )}
                    </div>

                    {/* Modal Footer Actions */}
                    <div className="flex items-center justify-end space-x-2 pt-2 border-t border-base-200">
                        <button
                            type="button"
                            disabled={loading}
                            onClick={handleCloseDisclaimer}
                            className={`btn btn-ghost btn-sm text-xs h-9 min-h-[36px] ${
                                loading ? 'btn-disabled opacity-30 cursor-not-allowed pointer-events-none' : ''
                            }`}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            disabled={!agreeToTerms || loading}
                            onClick={handleDisclaimerSubmit}
                            className={`btn btn-sm px-5 text-xs font-black uppercase tracking-wider h-9 min-h-[36px] transition-all ${
                                agreeToTerms && !loading
                                    ? 'btn-secondary text-white shadow-md hover:scale-[1.01] active:scale-[0.99] cursor-pointer'
                                    : loading
                                    ? 'btn-secondary text-white opacity-85 cursor-wait'
                                    : 'btn-disabled opacity-40 bg-base-300 text-base-content/40 cursor-not-allowed'
                            }`}
                        >
                            {loading ? (
                                <span className="inline-flex items-center space-x-2">
                                    <span className="loading loading-spinner loading-xs"></span>
                                    <span>Submitting...</span>
                                </span>
                            ) : (
                                'Submit Enrollment'
                            )}
                        </button>
                    </div>
                </div>
            </Modal>


            <Loading open={loading}>
                <div className='flex flex-col items-center space-y-4 text-center'>
                    <div className='text-white text-4xl'>Sending your Enrollment Form...</div>
                    <span className="loading loading-spinner loading-lg text-white"></span>
                </div>
            </Loading>

            <AlertError showError={showError} onClose={() => setShowError(false)}>{validationErrorText}</AlertError>

            {/* SUCCESS MESSAGE */}
            <Modal open={openModal} closeButton={false}>
                <div className='card'>
                    <div className='card-body p-4'>
                        <div className='text-xl card-title'>Enrollment Received</div>
                        <p className='text-sm'>
                            You will receive an email confirmation acknowledging your enrollment form.
                            If you do not see this email, please check your SPAM folder.  Please expect to hear from one of our agents soon who will guide you through the next step.
                            Thank you for trusting Insurance Enterprise USA for your health insurance needs.
                        </p>
                    </div>
                    <div className='flex justify-end card-actions'>
                        <button className='btn btn-secondary text-white px-7' onClick={handleCloseModal}>Close</button>
                    </div>
                </div>
            </Modal>
        </>
    );
}

export default EnrollmentForm;
